import React from 'react';
import { DayOfWeek, OpeningHoursSpecification } from 'schema-dts';

import { contact, timezone } from 'src/config.json';
import { usePathname } from 'src/hooks/router-hooks';

import { Schema } from '../Schema/Schema';

import { BranchDetail } from './BranchViewQuery';

type BranchViewSchemaProps = {
    detail: BranchDetail;
};

export const BranchViewSchema = React.memo(function BranchViewSchema(props: BranchViewSchemaProps) {
    const { detail } = props;
    const pathname = usePathname();

    const openingHoursSpecification: (OpeningHoursSpecification | null)[] = detail.opening_hours.map((openingHour) => {
        const day = openingHour?.day || null;
        const time = openingHour?.time || null;

        if (day === null || time === null) {
            return null;
        }

        const dayOfWeek = DayOfWeek[day];
        const times = time.split(' - ');
        const closes = `${times[1]} ${timezone}`;
        const opens = `${times[0]} ${timezone}`;

        return {
            '@type': 'OpeningHoursSpecification',
            closes,
            dayOfWeek,
            opens,
        };
    });

    const specialOpeningHoursSpecification = (() => {
        const dayOfWeek = DayOfWeek.PublicHolidays;
        const times = detail.bank_holiday_hours.split(' - ');
        const closes = `${times[1]} ${timezone}`;
        const opens = `${times[0]} ${timezone}`;

        return {
            '@type': 'OpeningHoursSpecification',
            closes,
            dayOfWeek,
            opens,
        };
    })();

    return (
        <Schema
            input={{
                '@context': 'http://schema.org',
                '@type': 'Store',
                address: {
                    '@type': 'PostalAddress',
                    addressCountry: {
                        '@type': 'Country',
                        name: 'IE',
                    },
                    addressLocality: detail.city,
                    addressRegion: detail.state,
                    streetAddress: detail.address,
                },
                description: detail.meta_description,
                geo: {
                    '@type': 'GeoCoordinates',
                    latitude: detail.latitude,
                    longitude: detail.longitude,
                },
                image: contact.logo,
                logo: contact.logo,
                name: detail.meta_title,
                openingHoursSpecification,
                priceRange: '€€',
                specialOpeningHoursSpecification,
                telephone: detail.phone,
                url: `${contact.publicUrl}${pathname}`,
            }}
        />
    );
});
